<template>
    <ul class="cell small-12 medium-5">
        <li class="card" v-for="(article,index) in item" :key="index">
            <article class="reviews_article card-section text-center">
                <p class="reviews_article--content" v-bind:class="{'reviews_article--content--small' : article.comments_is_small}" v-html="article.comments_content"></p>
                <h3 class="reviews_article--title" v-html="article.comments_title"></h3>
                <p v-show="article.comments_subtitle !== '' && article.comments_subtitle !== null && article.comments_subtitle !== undefined" class="reviews_article--subtitle" v-html="article.comments_subtitle"></p>
            </article>
        </li>
    </ul>
</template>

<script>

export default {
    name: 'reviews-item',
    props: {
        item: Array
    },
    data () {
        return {
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/ReviewsItem.vue